/**
 * General, conversation-independent explanations of each pattern. Safe to
 * show on the free result — they explain what a pattern is, never which
 * messages triggered it.
 */
export const patternDefinitions = [
  {
    match: ['gaslight'],
    text: 'Statements that question or rewrite your memory, perception, or feelings.',
  },
  {
    match: ['blame'],
    text: 'Responsibility for a problem is redirected onto you instead of being owned.',
  },
  {
    match: ['dismiss', 'invalidat'],
    text: 'Your concerns or emotions are minimized, brushed aside, or treated as overreaction.',
  },
  {
    match: ['darvo'],
    text: 'Deny, attack, and reverse victim and offender when challenged.',
  },
  {
    match: ['guilt'],
    text: 'Guilt is used as leverage to change your behavior or decisions.',
  },
  {
    match: ['coerc', 'control'],
    text: 'Language that limits your choices or pushes compliance through pressure.',
  },
  {
    match: ['pressure', 'urgen'],
    text: 'Emotional intensity or urgency is used to push a response from you.',
  },
  {
    match: ['boundar'],
    text: 'A stated limit or request is ignored, tested, or argued against.',
  },
  {
    match: ['stonewall', 'silent'],
    text: 'Withdrawal or refusal to engage is used to end or control the conversation.',
  },
  {
    match: ['passive'],
    text: 'Hostility expressed indirectly through sarcasm, backhanded remarks, or tone.',
  },
  {
    match: ['manipulat'],
    text: 'Indirect tactics that steer your feelings or decisions without being upfront.',
  },
  {
    match: ['love bomb', 'love-bomb'],
    text: 'Intense affection or praise used to create attachment or obligation.',
  },
]

export const genericPatternDefinition =
  'A recurring communication pattern associated with unhealthy dynamics.'

export function getPatternDefinition(type: string): string {
  const lower = type.toLowerCase()
  const found = patternDefinitions.find((def) =>
    def.match.some((m) => lower.includes(m)),
  )
  return found ? found.text : genericPatternDefinition
}
